export default (x) => Object.keys(x).map((k) => x[k])



// WEBPACK FOOTER //
// ./~/@klarna/ui/lib/values.js